import { FleetSetting } from "./types";

export const transformFleetSetting = (res: any): FleetSetting => {
  return {
    vehicleCategories: (res.vehicleCategories || []).map((c: any) => ({
      id: c.id,
      name: c.name,
    })),
    selectedVehicleCategories: (res.selectedVehicleCategories || []).map((c: any) => ({
      id: c.id,
      name: c.name,
    })),
    vehicleSteps: (res.vehicleSteps || []).map((s: any) => ({
      key: s.key,
      required: !!s.required,
    })),
    enabledVehicleStepKeys: res.enabledVehicleStepKeys || [],
  };
};
